var NEW = 'NEW';
var EDIT = 'EDIT';
var MODES = {
  NEW: NEW,
  EDIT: EDIT
};
export default MODES;